<template>
    <v-card-text class="pa-6">

        <!-- Sezione Dati Utente -->
        <div class="section-container mb-8">
            <div class="section-header mb-4">
                <v-icon color="primary" size="20">mdi-account-circle</v-icon>
                <h3 class="section-title">Informazioni Account</h3>
            </div>

            <v-row>
                <v-col cols="12" md="6">
                    <v-text-field label="Username" v-model="localUtente.username" readonly variant="outlined"
                        density="comfortable" prepend-inner-icon="mdi-account" bg-color="grey-lighten-4" />
                </v-col>

                <v-col cols="12" md="6">
                    <v-text-field label="Email" v-model="localUtente.email" variant="outlined" density="comfortable"
                        prepend-inner-icon="mdi-email" type="email" />
                </v-col>
            </v-row>

            <div class="d-flex justify-end">
                <v-btn color="primary" :loading="loadingSalvaUtente" @click="salvaUtente"
                    prepend-icon="mdi-content-save" variant="flat" size="large">
                    Salva modifiche
                </v-btn>
            </div>
        </div>

        <v-divider class="my-6" />

        <!-- Sezione Cambio Password -->
        <div class="section-container">
            <div class="section-header mb-4">
                <v-icon color="primary" size="20">mdi-lock-reset</v-icon>
                <h3 class="section-title">Sicurezza</h3>
            </div>

            <v-alert type="info" variant="tonal" class="mb-4" density="compact">
                La password deve contenere almeno 8 caratteri
            </v-alert>

            <v-row>
                <v-col cols="12" md="4">
                    <v-text-field label="Password attuale" v-model="localPassword.old"
                        :type="showPass ? 'text' : 'password'" variant="outlined" density="comfortable"
                        prepend-inner-icon="mdi-lock" :append-inner-icon="showPass ? 'mdi-eye-off' : 'mdi-eye'"
                        @click:append-inner="showPass = !showPass" />
                </v-col>

                <v-col cols="12" md="4">
                    <v-text-field label="Nuova password" v-model="localPassword.new"
                        :type="showPass ? 'text' : 'password'" variant="outlined" density="comfortable"
                        prepend-inner-icon="mdi-lock-plus" />
                </v-col>

                <v-col cols="12" md="4">
                    <v-text-field label="Conferma password" v-model="localPassword.confirm"
                        :type="showPass ? 'text' : 'password'" variant="outlined" density="comfortable"
                        prepend-inner-icon="mdi-lock-check"
                        :error-messages="passwordMismatch ? 'Le password non coincidono' : ''" />
                </v-col>
            </v-row>

            <div class="d-flex justify-end">
                <v-btn color="primary" :loading="loadingPassword" :disabled="!canChangePassword" @click="cambiaPassword"
                    prepend-icon="mdi-key-change" variant="flat" size="large">
                    Aggiorna password
                </v-btn>
            </div>
        </div>

        <!-- Snackbar -->
        <v-snackbar v-model="snackbar.show" :color="snackbar.color" location="bottom right" :timeout="3000">
            {{ snackbar.text }}
        </v-snackbar>

    </v-card-text>
</template>

<script>
import { aggiorna_dati_utente, cambia_password } from "@/api/api.profilo"

export default {
    name: "TabUtente",

    props: {
        utente: {
            type: Object,
            required: true
        },
    },

    emits: ['update:utente'],

    data() {
        return {
            showPass: false,
            localUtente: {
                username: this.utente?.username || "",
                email: this.utente?.email || ""
            },
            localPassword: {
                old: "",
                new: "",
                confirm: ""
            },
            loadingSalvaUtente: false,
            loadingPassword: false,
            snackbar: {
                show: false,
                text: "",
                color: "success"
            }
        }
    },

    computed: {
        passwordMismatch() {
            return this.localPassword.confirm !== "" &&
                this.localPassword.new !== this.localPassword.confirm
        },

        canChangePassword() {
            return this.localPassword.old !== "" &&
                this.localPassword.new !== "" &&
                this.localPassword.confirm !== "" &&
                !this.passwordMismatch
        }
    },

    watch: {
        'utente.username'(val) {
            if (val !== this.localUtente.username) {
                this.localUtente.username = val
            }
        },
        'utente.email'(val) {
            if (val !== this.localUtente.email) {
                this.localUtente.email = val
            }
        }
    },

    methods: {
        notify(text, color = "success") {
            this.snackbar = { show: true, text, color }
        },

        async salvaUtente() {
            this.loadingSalvaUtente = true
            try {
                await aggiorna_dati_utente({
                    username: this.localUtente.username,
                    email: this.localUtente.email
                })
                this.notify("Dati aggiornati con successo.")
                // Emetti l'aggiornamento al parent
                this.$emit('update:utente', {
                    username: this.localUtente.username,
                    email: this.localUtente.email
                })
            } catch {
                this.notify("Errore durante il salvataggio.", "error")
            } finally {
                this.loadingSalvaUtente = false
            }
        },

        async cambiaPassword() {
            if (!this.canChangePassword) return

            this.loadingPassword = true
            try {
                await cambia_password({
                    old: this.localPassword.old,
                    new: this.localPassword.new,
                    confirm: this.localPassword.confirm
                })
                // Reset del form
                this.localPassword = { old: "", new: "", confirm: "" }
                this.notify("Password aggiornata con successo.")
            } catch (err) {
                const msg = err?.response?.status === 400
                    ? "Password attuale non corretta."
                    : "Errore durante l'aggiornamento della password."
                this.notify(msg, "error")
            } finally {
                this.loadingPassword = false
            }
        }
    }
}
</script>

<style scoped>
.section-container {
    background-color: #fafafa;
    border-radius: 8px;
    padding: 20px;
}

.section-header {
    display: flex;
    align-items: center;
    gap: 8px;
}

.section-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
}
</style>